import { useEffect } from 'react';

import { faCartShopping } from '@awesome.me/kit-379289146f/icons/classic/solid';
import { PrimaryButton } from '@changegps/horizon-component-library';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { SubscriptionForm, useCreateCheckoutForm } from '../hooks';

import { SummaryBox, SummaryBoxTitle } from './Filters.components';

export const Checkout = ({ toggleDrawer }: { toggleDrawer: () => void }) => {
  const { watch } = useFormContext<SubscriptionForm>();
  const { setValue } = useCreateCheckoutForm();

  const data = watch();
  const keys = Object.keys(data).filter((item) => item !== 'coupon') as Array<
    keyof SubscriptionForm
  >;

  const totalPrice = keys.reduce((sum, key) => {
    const productData = data[key];
    if (
      productData &&
      typeof productData === 'object' &&
      productData.price &&
      productData.type
    ) {
      if (
        productData.type.toLowerCase().includes('enterprise') &&
        productData.count
      )
        return sum + productData.price * productData.count;
      return sum + productData.price;
    }
    return sum;
  }, 0);

  const fee1 = totalPrice * 0.05;
  const fee2 = (totalPrice + fee1) * 0.1;
  const grandTotal = totalPrice + fee1 + fee2;

  useEffect(() => {
    setValue('total', totalPrice);
  }, [totalPrice]);

  return (
    <Stack gap={1}>
      <Typography fontSize={36} fontWeight={100}>
        Checkout
      </Typography>
      <Stack gap={2}>
        <SummaryBox>
          <SummaryBoxTitle>Total Subscription Amount</SummaryBoxTitle>
          <Stack padding={'14px 15px'} gap={1}>
            <Typography fontSize={18}>Total</Typography>
            <Typography fontSize={28} fontWeight={600}>
              ${totalPrice.toLocaleString()}
            </Typography>
            <Stack direction="row" justifyContent="space-between">
              <Typography fontSize={16}>EVO Fee</Typography>
              <Typography fontSize={16}>
                $
                {fee1.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography fontSize={16}>CSP Fee</Typography>
              <Typography fontSize={16}>
                $
                {fee2.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{
                borderTop: '1px solid #eee',
                pt: 1,
                mt: 1,
              }}
            >
              <Typography fontSize={18} fontWeight={700}>
                Grand Total
              </Typography>
              <Typography
                fontSize={22}
                fontWeight={700}
                color="primary"
              >{`$${grandTotal.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}</Typography>
            </Stack>
          </Stack>
        </SummaryBox>
        <PrimaryButton onClick={toggleDrawer}>
          <FontAwesomeIcon icon={faCartShopping as IconProp} size="lg" />
          &nbsp; Checkout
        </PrimaryButton>
      </Stack>
    </Stack>
  );
};
